/* ==========================================================================
   SERPROMAQ - INTEGRACIÓN FLOTANTE DE ATENCIÓN POR WHATSAPP
   ========================================================================== */

const DEFAULT_PHONE = '573168275829';

export function initWhatsAppWidget() {
  const whatsappBubble = document.getElementById('whatsappBubble');
  const whatsappTooltipText = document.getElementById('whatsappTooltipText');

  if (!whatsappBubble) return;

  // Contextual messages per section
  const messagesBySection = {
    'inicio': 'Hola 👋 ¿En qué podemos ayudarte hoy?',
    'servicios': 'Hola 🚜 ¿Necesitas asesoría sobre alquiler o venta de montacargas?',
    'nosotros': 'Hola 🏭 ¿Deseas conocer más sobre nuestra cobertura técnica?',
    'contacto': 'Hola 📞 Estamos listos para atender tu consulta comercial.'
  };

  // Update tooltip based on scroll position
  window.addEventListener('scroll', () => {
    const sections = document.querySelectorAll('section[id]');
    const scrollY = window.pageYOffset;

    sections.forEach(current => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop - 200;
      const sectionId = current.getAttribute('id');

      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
        if (messagesBySection[sectionId] && whatsappTooltipText) {
          whatsappTooltipText.textContent = messagesBySection[sectionId];
        }
      }
    });
  });

  // Handle WhatsApp Click
  whatsappBubble.addEventListener('click', () => {
    // Check current active section for dynamic message
    const activeSection = document.querySelector('section[id]:hover') || document.querySelector('section[id]');
    const sectionId = activeSection ? activeSection.getAttribute('id') : 'general';

    let messageText = 'Hola, me gustaría recibir información sobre la venta, alquiler y servicios de SERPROMAQ.';

    if (sectionId === 'servicios') {
      messageText = 'Hola, me gustaría recibir asesoría personalizada sobre el alquiler y venta de montacargas.';
    } else if (sectionId === 'contacto') {
      messageText = 'Hola, quisiera ponerme en contacto directo con un asesor comercial de SERPROMAQ.';
    }

    const url = `https://wa.me/${DEFAULT_PHONE}?text=${encodeURIComponent(messageText)}`;
    window.open(url, '_blank');
  });
}
